import pointInPolygon from './pointInPolygon'

export default function findNeighborhoodByCoordinates(
  mouse,
  { dx, dy, areas, xScale, yScale, transform: t }
) {
  const x = xScale.invert(mouse[0] - dx * t.k)
  const y = yScale.invert(mouse[1] - dy * t.k)

  return areas.find((a) => a.areaType === 'neighborhood' && pointInPolygon([x, y], a))
}
